import { IAction, IState } from '../initialValues'

export const videoCaptureReducer = (state: IState, action: IAction): IState => {
    const actionHandlers: {
        [key: string]: (state: IState, payload: any) => IState
    } = {
        SET_VIDEO_SOURCE: (state, payload) => ({
            ...state,
            videoSrc: payload,
        }),
        SET_MEDIA_RECORDER: (state, payload) => ({
            ...state,
            mediaRecorder: payload,
        }),
        SET_IS_RECORDING: (state, payload) => ({
            ...state,
            isRecording: payload,
        }),
        SET_IS_UPLOADING: (state, payload) => ({
            ...state,
            isUploading: payload,
        }),
        SET_TIMER: (state, payload) => ({
            ...state,
            timer: payload,
        }),
        SET_SHOW_MODAL: (state, payload) => ({
            ...state,
            showModal: payload,
        }),
        SET_RANDOM_PHARSE: (state, payload) => ({
            ...state,
            randomPhrase: payload,
        }),
    }
    const handler = actionHandlers[action.type]
    return handler ? handler(state, action.payload) : state
}
